export default (hex, brightnessThreshold) => {
  // Remover o # do início, se estiver presente
  hex = hex.replace('#', '')

  // Converter o código hexadecimal para RGB
  var r = parseInt(hex.substring(0, 2), 16)
  var g = parseInt(hex.substring(2, 4), 16)
  var b = parseInt(hex.substring(4, 6), 16)

  // Calcular o brilho da cor
  var brightness = ((r * 299) + (g * 587) + (b * 114)) / 1000

  // Verificar se o brilho da cor é maior que o limite fornecido
  return brightness > (brightnessThreshold / 100 * 255) // Normalizando o limite para o intervalo [0, 255]
}
